import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import SubTitle from "../../../../components/elements/SubTitle";
import {Typography} from "@mui/material";
import {currencySymbol, getDisplayTime, getMediaURL, price, truncate} from "../../../../../config/values";

function RecentDonates({classes}){
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([])

    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const loadData = () =>{
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/recent-donates`,config)
            .then(response => {
                setItems(response.data)

                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    useEffect(() => {
        loadData();
    }, []);
    return (
        <div className="recent-donors ">
            {
                !loading &&
                <>
                    {
                        !!items.length &&
                        <SubTitle align="left" className="dialog-title my-15">{t('recentDonates')}</SubTitle>
                    }
                    <div className="scrollable">
                        {
                            items.map((item,index) => (
                                <div className='donor-item' key={index}>
                                    <div className="flex-direction charity" style={{gap:3}}>
                                        <img className={"charity-logo"} src={getMediaURL(item.charity?.file,'small')} alt={item.charity?.name}/>
                                        <Typography>{truncate(`${item.charity?.name}`,15)}</Typography>
                                    </div>
                                    <div className="flex-space">
                                        <Typography className="bold">{truncate(`${item.user?.first_name} ${item.user?.last_name}`, 14)}</Typography>
                                        <Typography>{price(item.amount)} {currencySymbol}</Typography>
                                    </div>
                                    <Typography className="date-box">{getDisplayTime(item.created_at)}</Typography>

                                </div>
                            ))
                        }
                    </div>

                </>
            }
        </div>
    );
}
export default withStyles(Styles)(RecentDonates);
